import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Mail } from "lucide-react";

export default function AirCompressorPage() {
    return (
        <div className="min-h-[70vh]" data-testid="air-compressor-page">
            <div className="bg-card border-b border-border">
                <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20">
                    <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Supporting Equipment</p>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-foreground tracking-tight mb-4">
                        Air Compressors
                    </h1>
                    <p className="text-muted-foreground text-base sm:text-lg max-w-2xl">
                        High-performance air compressors designed for dry ice blasting applications. Matched to your machine for optimal output and efficiency.
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20">
                <div className="bg-card border border-border p-8 lg:p-12 text-center max-w-2xl mx-auto">
                    <div className="w-16 h-16 bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-6">
                        <span className="font-heading font-black text-primary text-2xl">!</span>
                    </div>
                    <h2 className="font-heading text-lg font-bold text-foreground mb-3">
                        Compressor Matching Service
                    </h2>
                    <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                        The right compressor depends on your blasting machine and application. Contact us for expert recommendations and competitive pricing on air compressors tailored to your setup.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <Link to="/quote">
                            <Button
                                className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none uppercase font-bold tracking-wider px-8"
                                data-testid="air-compressor-quote-btn"
                            >
                                Get Compressor Quote
                            </Button>
                        </Link>
                        <a href="mailto:sales@dryicemarketplace.com" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm">
                            <Mail className="h-4 w-4" />
                            sales@dryicemarketplace.com
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
